import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AlertMessageService {
    constructor(private _snackBar: MatSnackBar, private _router: Router) {}

    error(message: string) {
        this._snackBar.open(message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['danger-snackbar'],
        });
    }

    errors(messages: string[]) {
        messages.forEach((element) => {
            this._snackBar.open(element, '', {
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: ['danger-snackbar'],
            });
        });
    }

    success(message: string, duration: number | null = 3000) {
        const snackBarRef = this._snackBar.open(message, '', {
            duration: duration,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['success-snackbar'],
        });
        this._router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                snackBarRef.dismiss();
            }
        });
    }

    info(message: string) {
        this._snackBar.open(message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['blue-info-snackbar'],
        });
    }

    warning(message: string) {
        this._snackBar.open(message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['warning-snackbar'],
        });
    }
}
